import axios from 'axios'
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'cuti',
    state: {
        cuti: []
    },
    getters: {
        getCuti: state => {
            return state.cuti
        }
    },
    mutations: {
        CUTI: (state, payload) => {
            state.cuti = payload
        },
    },
    actions: {
        FETCH_CUTI_DETAIL(store, payload) {
            return axios({
                method: 'get',
                url: ServiceURL + 'cuti/data_cuti',
                params: {
                    tlc: payload
                },
                auth: {
                    username: store.rootState.auth.auth.username,
                    password: store.rootState.auth.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.auth.auth.apikey
                }
            }).then(response => {
                store.commit('CUTI', response.data)
            }).catch(err => {
                return err
            })
        }
    }
}
